import { hasWithoutCompetitors } from 'shared/components/SimilarOffersRedesigned/utils/hasWithoutCompetitors';

import { ISimilarState } from '../store/similar';

export function itemBasedOffersVisible(state: ISimilarState): boolean {
  return !hasWithoutCompetitors(state) && state.itemBased.list.length > 0;
}
